import { CHAIN_ID_PAGES } from 'config';
import { HomePage } from 'views';

const IndexPage = () => {
    return <HomePage />
}
IndexPage.chains = CHAIN_ID_PAGES;

export default IndexPage
